<div class="olci-top-alert">
	<rcg-notification-message
		*ngFor="let error of errorMessages"
		class="container no-print"
		[brand]="brandName"
		[variant]="'inline'"
		[type]="error.errorType"
		[notificationId]="'uniqueId'"
		[description]="error.errorMessage"
		[dismissible]="false"
	></rcg-notification-message>
</div>
